<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>ગામ</h3>
        </div>
    </div>
</header>
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="searchVillage($event)"
                    placeholder="ગામ શોધો.." />
                <i class="ti ti-search"></i>
            </form>
        </div>
    </div>
    <hr>

    <div class="city-list district_list table-responsive">
        <table class="member-list-item">
            <thead>
                <tr>
                    <th class="table-header">ગામડાઓ</th>
                    <th class="table-header"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of VillageList">
                    <td class="td-spacing cursorClass" (click)="ListMainMember(data.village_id)">
                        <h5>{{data.village_name}}</h5>
                    </td>
                    <td class="td-spacing">
                        <button (click)="ListMainMember(data.village_id)" class="btn-common edit-btn">
                            <span>{{data.persons}}</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</main>